import { CheckIcon } from '@heroicons/react/24/solid'
import type React from 'react'

type IconOnTheLeftWithContentLayoutProps = {
  mainContent: React.ReactNode
  children?: React.ReactNode
  icon?: React.ReactNode
}

export function IconOnTheLeftWithContentLayout({
  mainContent,
  children
}: IconOnTheLeftWithContentLayoutProps) {
  return (
    <div className='flex flex-col gap-2'>
      <div className='flex flex-row items-center gap-x-3'>
        <CheckIcon className='h-6 w-6 text-algoprimary' />
        <div className='flex-1'>{mainContent}</div>
      </div>
      <div>{children}</div>
    </div>
  )
}
